<script>
  import API from '../Stores/API';
  import Trail from '../Components/Trail';
  import View from '../Stores/View';
  import {afterUpdate} from 'svelte';

  let context = '';
  let subscription = $View.config.subscription;

  let map;
  let geocoder;
  let marker;
  let map_init = false;
  let map_element = {};
  let latitude_element = {};
  let longitude_element = {};
  let cemetery_name_element = {};
  let cemetery_address_element = {};
  let cemetery_city_element = {};
  let force_map = false;

  function setMarker(location) {
      if (marker) marker.setMap(null);
      marker = new window.google.maps.Marker({
        map: map,
        position: location,
        title: 'Locatie Graf'
      });

      latitude_element.value = typeof location.lat === 'function' ? location.lat() : location.lat;
      longitude_element.value = typeof location.lng === 'function' ? location.lng() : location.lng;
  }

  function setGeocode(address) {
    geocoder.geocode({address}, (results, status) => {
      if (status === 'OK') {
        const location = results[0].geometry.location;
        map.setCenter(location);
        map.setZoom(18);
        setMarker(location);
      }
      else console.error(status);
    });
  }

  function setMap() {
    try {
      const custom = !!latitude_element.value;
      const zoom = custom ? 18 : 14;

      const lat = parseFloat(latitude_element.value) || 52.3676;
      const lng = parseFloat(longitude_element.value) || 4.9041;
      const location = {lat, lng};

      map = new window.google.maps.Map(map_element, {
        zoom: zoom,
        center: location,
        mapTypeId: window.google.maps.MapTypeId.SATELLITE
      });

      map.addListener('click', event => setMarker(event.latLng));
      geocoder = new window.google.maps.Geocoder();
      if (custom) setMarker(location);
    }
    catch (error) { console.error(error); }
  }

  function setMarkerUpdate(event) {
    const name = cemetery_name_element.value.trim();
    const address = cemetery_address_element.value.trim();
    const city = cemetery_city_element.value.trim();
    if (address && city) {
      const place = [name, address, city, 'NL'].filter(Boolean).join(', ');
      setGeocode(place);
    }
  }

  async function setSave() {
    const values = new FormData(form);
    const data = Object.fromEntries(values.entries());
    await API.getRequest(`subscriptions/${subscription.id}`, 'post', data);
    await API.setData();
    View.setView('subscription', {subscription, notice: 'Jouw abonnement is aangepast!'});
  }

  afterUpdate(() => {
    if ($API.data && (force_map || (!subscription.plot.verified && !map_init))) {
      map_init = true;
      setMap();
    }
  });
</script>

<style>
  div.map {
    height: 40em;
  }
</style>

{#if $API.data}
  <Trail path="{[['Account', () => View.setView('dashboard')], [subscription.plot.departed.name, () => View.setView('subscription', {subscription})], ['Aanpassen']]}"/>

  <section class="pt-8 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 text-center text-white">
          <h1 class="display-3 mb-4">{subscription.plot.departed.name}</h1>
          <p class="fs-lg">Hieronder kun je de gegevens van dit abonnement aanpassen of aanvullen.</p>
        </div>
      </div>
    </div>
  </section>

  <form on:submit|preventDefault="{setSave}">
    <section class="position-relative pt-4 pb-2 bg-dark">
      <div class="container-lg">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6">
            <label for="email" class="form-label text-white text-uppercase fw-bold">Overledene</label>
            <div class="form-group">
              <label class="visually-hidden" for="deceased_name">Naam zoals op het Graf</label>
              <input class="form-control" id="deceased_name" name="deceased_name" type="text" required="required" value="{subscription.plot.departed.name}" placeholder="Naam zoals op het Graf"/>
            </div>
            <div class="form-group">
              <label class="visually-hidden" for="deceased_date">Datum van Overlijden</label>
              <input class="form-control" id="deceased_date" name="deceased_date" type="text" required="required" value="{subscription.plot.departed.date_of_death}" placeholder="Datum van Overlijden"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    {#if force_map || !subscription.plot.verified}
      <section class="position-relative pt-2 pb-2 bg-dark">
        <div class="container-lg">
          <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6">
              <label for="email" class="form-label text-white text-uppercase fw-bold mt-4">Begraafplaats</label>
              <div class="form-group">
                <label class="visually-hidden" for="cemetery">Begraafplaats</label>
                <input bind:this="{cemetery_name_element}" on:change="{setMarkerUpdate}" class="form-control" id="cemetery" name="cemetery" type="text" required="required" value="{subscription.plot.cemetery.name}" placeholder="Begraafplaats"/>
              </div>
              <div class="form-group">
                <label class="visually-hidden" for="cemetery_address">Adres</label>
                <input bind:this="{cemetery_address_element}" on:change="{setMarkerUpdate}" class="form-control" id="cemetery_address" name="cemetery_address" type="text" required="required" value="{subscription.plot.cemetery.address}" placeholder="Adres"/>
              </div>
              <div class="form-group">
                <label class="visually-hidden" for="cemetery_city">Plaats</label>
                <input bind:this="{cemetery_city_element}" on:change="{setMarkerUpdate}" class="form-control" id="cemetery_city" name="cemetery_city" type="text" required="required" value="{subscription.plot.cemetery.city.name}" placeholder="Plaats"/>
              </div>
              <label for="email" class="form-label text-white text-uppercase fw-bold mt-4">Locatie</label>
              <p class="text-white mb-2">Om ervoor te zorgen dat we het juiste graf onderhouden, verzoeken wij je om zo specifiek mogelijk de locatie van het graf op te geven. Dit kun je doen door op de juiste plek op de kaart te klikken.</p>
            </div>
          </div>
        </div>
      </section>
      <section class="position-relative pt-4 pb-4 bg-dark">
        <div class="container-lg">
          <div class="row justify-content-center">
            <div class="col-12">
              <input bind:this="{latitude_element}" type="hidden" id="latitude" name="lat" value="{subscription.plot.location.lat}"/>
              <input bind:this="{longitude_element}" type="hidden" id="longitude" name="lng" value="{subscription.plot.location.lng}"/>
              <div bind:this="{map_element}" class="map position-relative rounded"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="position-relative pt-2 pb-2 bg-dark">
        <div class="container-lg">
          <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6">
              <p class="text-white mb-6">Als je het grafnummer of andere specifieke details hebt, vermeld deze dan ook. Dit helpt ons om de onderhoudsdiensten zo nauwkeurig mogelijk uit te voeren.</p>
              <div class="form-group">
                <label class="visually-hidden" for="plot_position">Grafnummer indien Bekend</label>
                <input class="form-control" id="plot_position" name="plot_position" type="text" value="{subscription.plot.position}" placeholder="Grafnummer indien bekend"/>
              </div>
              <div class="form-group">
                <label class="visually-hidden" for="plot_remark">Eventuele opmerkingen</label>
                <textarea class="form-control" id="plot_remark" name="plot_remark" rows="4" placeholder="Eventuele opmerkingen">{subscription.plot.remark}</textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
    {:else}
      <section class="position-relative pt-2 pb-2 bg-dark">
        <div class="container-lg">
          <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6">
              <label class="form-label text-white text-uppercase fw-bold mt-4">Locatie</label>
              <div class="alert alert-secondary">
                <b>De locatie van het graf is door ons bevestigd.</b><br/>
                Je kunt deze nu niet meer aanpassen.<br/><br/>
                <b>{subscription.plot.cemetery.name}</b><br/>
                {subscription.plot.cemetery.address}<br/>
                {subscription.plot.cemetery.city.name}
              </div>
            </div>
          </div>
        </div>
      </section>
    {/if}

    <section class="position-relative pt-2 pb-2 bg-dark">
      <div class="container-lg">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6">
            <button class="btn w-100 mt-4 btn-primary-light">Opslaan</button>
            <button class="btn w-100 mt-4 btn-primary" on:click="{event => { View.setView('subscription', {subscription}) }}">Annuleren</button>
          </div>
        </div>
      </div>
    </section>
  </form>

  <section class="position-relative pt-12 pb-10 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <form>
            <hr class="hr-sm bg-warning mx-auto mb-8">
            <h2 class="display-4 text-white text-center">Abonnement <span class="text-underline-warning">Opzeggen.</span></h2>
            <p class="fs-lg text-white text-center">Als je geen gebruik meer van onze diensten wilt maken dan kun je hieronder jouw gegevens downloaden en het abonnement opzeggen.</p>
            <button class="btn w-100 mt-2 btn-primary">Gegevens Downloaden</button>
            <button class="btn w-100 mt-4 btn-danger">Abonnement Opzeggen</button>
          </form>
        </div>
      </div>
    </div>
  </section>
{/if}